import { Flex, HStack, Box, StackProps } from "@chakra-ui/layout";
import {
  forwardRef, Grid,
  Icon,
  Image,
  Modal, ModalBody,
  ModalCloseButton,
  ModalContent, ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { ClockIcon } from "@components/Icons/ClockIcon";
import moment from "moment";
import React from "react";
import getReadingTime from "@utils/readingTime";
import share from "@images/share.svg";
import facebook from "@images/facebook-filled.svg";
import twitter from "@images/twitter.svg";
import messenger from "@images/messenger.svg";
import { EmailIcon, ExternalLinkIcon } from "@chakra-ui/icons";
import { preparePostUrl } from "@core/utils";

export const SharePost = ({title, article,link, ...props}) => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    const shareContent = (e:  React.MouseEvent<HTMLElement>) => {
      e.preventDefault()
      onOpen()
    }
    const copyLink = () => {
      navigator.clipboard.writeText(getUri()).then(() => onClose())
    }
    const shareByEmail = () => {
      window.open(`mailto:?subject=${title}&body=${getUri()}`)
      onClose()
    }
    const shareByTwitter = () => {
      const url = `https://twitter.com/intent/tweet?url=${getUri()}&via=getboldify&text=${title}`;
      window.open(url, 'TwitterWindow');
      onClose()
    }
    const shareByFacebook = () => {
      const url = `https://www.facebook.com/sharer/sharer.php?u=${getUri()}&t=${title}`;
      window.open(url);
      onClose()
    }
    const shareByMessenger = () => {
      window.open(`fb-messenger://share?link=${getUri()}`);
      onClose()
    }
    const getUri = () => {
      return `${window.location.origin}${link ? link : preparePostUrl(article)}`
    }

    const sharePlatforms = [
      {
        name: "Facebook",
        img: facebook,
        action: shareByFacebook
      },
      {
        name: "Twitter",
        img: twitter,
        action: shareByTwitter
      },
      {
        name: "Messenger",
        img: messenger,
        action: shareByMessenger
      },
      {
        name: "Kopiuj link",
        icon: <ExternalLinkIcon/>,
        action: copyLink
      },
      {
        name: "E-mail",
        icon: <EmailIcon/>,
        action: shareByEmail
      }
    ];

    return (
      <>
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay  />
          <ModalContent maxW="100vw"  w='100vw' borderRadius="0" alignSelf="flex-end" m="0" >
            <ModalHeader color="#222C63">Udostępnij dalej</ModalHeader>
            <ModalBody mb="20px">
              <Grid gridGap="15px" templateColumns={{base: "repeat(2, 1fr)", sm: "repeat(3, 1fr)", md: "repeat(4, 1fr)"}} >
                {
                  sharePlatforms.map((platform) => (
                    <Flex key={platform.name} onClick={() => platform.action()} cursor="pointer" alignItems="center" gridGap="15px">
                      {platform.img
                        ?
                        <Image w="30px" h="30px" src={platform.img}/>
                        : <Flex w="30px" h="30px" justifyContent="center" alignItems="center" borderRadius="50%" border="1px solid #222C63">
                          {platform.icon}
                        </Flex>
                      }
                      <Box fontWeight="bold">{platform.name}</Box>
                    </Flex>
                  ))
                }
              </Grid>
            </ModalBody>
          </ModalContent>
        </Modal>
        <Image {...props} src={share} onClick={shareContent} width="15px" mr="15px"/>
      </>
    );
  }
